import { render, staticRenderFns } from "./CreateConfirmedEmailComponent.vue?vue&type=template&id=2fe74690&scoped=true"
import script from "./CreateConfirmedEmailComponent.vue?vue&type=script&lang=js"
export * from "./CreateConfirmedEmailComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateConfirmedEmailComponent.vue?vue&type=style&index=0&id=2fe74690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe74690",
  null
  
)

export default component.exports